import { z } from 'zod';

export const venueDateDtoSchema = z.object({
  id: z.number(),
  organisationId: z.number(),
  startDate: z.string(),
  name: z.string(),
  properties: z
    .object({
      presetId: z.number().optional(),
      avgCapacity: z.number().optional(),
      customAvgCapacity: z.boolean().optional(),
    })
    .optional(),
  results: z
    .object({
      ess: z
        .object({
          stats: z
            .object({
              totalMen: z.number().optional(),
              totalOther: z.number().optional(),
              totalWomen: z.number().optional(),
            })
            .optional(),
        })
        .optional(),
    })
    .optional(),
  models: z
    .object({
      env: z.string(),
      ess: z.string(),
    })
    .optional(),
});

export const getVenueDatesDtoSchema = z.object({
  data: z.array(venueDateDtoSchema),
  limit: z.number(),
  skip: z.number(),
  total: z.number(),
});

export type VenueDateDto = z.infer<typeof venueDateDtoSchema>;

export const importDatesFromHeedsDtoSchema = z.array(
  z.object({
    date: z.string(),
    name: z.string(),
  }),
);

export const importDatesFromOrfeoDtoSchema = z.array(
  z.object({
    date: z.string(),
    name: z.string(),
  }),
);
